import { ReactElement } from 'react';
import AppRoutes from 'shell/router';
import 'shell/theme/main.scss';
import ErrorCatcher from 'shell/error/components/error-boundary';
import { Provider as EventBusProvider } from 'shell/hooks/use-bus';
import { HttpProvider } from 'shell/providers/http-custom-provider';
import { HttpLoadingProvider } from 'shell/hooks/use-http-loading';
import { ThemeProvider } from 'shell/providers/theme-provider';
import { BrowserRouter } from 'react-router-dom';
import { AuthenticationProvider } from 'shell/hooks/use-user-profile/provider';
import { ErrorHandlerProvider } from 'shell/error/providers/error-provider';
import { ErrorHandler } from 'shell/error/components/error-modal';
import { LocalizationProvider } from '@mui/lab';
import AdapterLuxon from '@mui/lab/AdapterLuxon';
import { ToastContainer } from 'react-toastify';
import store from 'store';
import { Provider as ReduxProvider } from 'react-redux';
import { OtpModalProvider } from 'shell/hooks/use-otp-modal/provider';

/**
 * Funzione App
 * @returns {React.ReactComponentElement} - return React Component Element
 */
const App = (): ReactElement => (
  <ErrorCatcher>
    <ErrorHandlerProvider>
      <ReduxProvider store={store}>
        <AuthenticationProvider>
          <HttpLoadingProvider>
            <EventBusProvider>
              <HttpProvider>
                <ToastContainer hideProgressBar position="top-right" theme="colored" />
                <ThemeProvider>
                  <OtpModalProvider>
                    <BrowserRouter>
                      <LocalizationProvider
                        locale="it"
                        dateAdapter={AdapterLuxon}
                        dateFormats={{ keyboardDate: 'dd/MM/yyyy' }}
                      >
                        <ErrorHandler />
                        <AppRoutes />
                      </LocalizationProvider>
                    </BrowserRouter>
                  </OtpModalProvider>
                </ThemeProvider>
              </HttpProvider>
            </EventBusProvider>
          </HttpLoadingProvider>
        </AuthenticationProvider>
      </ReduxProvider>
    </ErrorHandlerProvider>
  </ErrorCatcher>
);

App.displayName = 'S.I.De App';

export default App;
